var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.193,
    height: 16.679,
    viewBox: "0 0 15.193 16.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(-0.251 -0.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 7.22,
    transform: "translate(4.254 12.225)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 7.22,
    transform: "translate(4.254 8.66)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 2.755,
    transform: "translate(4.653 5.102)",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M11.105.75l-6.549,0A3.62,3.62,0,0,0,.751,4.673v7.832a3.623,3.623,0,0,0,3.838,3.924l6.549,0a3.621,3.621,0,0,0,3.807-3.921V4.673A3.624,3.624,0,0,0,11.105.75Z",
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextgray);
export default __webpack_public_path__ + "static/media/textgray.6402929b6a471602a221148e06c52f40.svg";
export { ForwardRef as ReactComponent };